import React from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import "containers/Spotlight/MySpotlight.css";
import "containers/ProjectCommon.css";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import BlockedListContainer from "../../../../components/Tribe/Friends/BlockedListContainer";

class BlockedUsers extends React.Component {
    constructor(props) {
        super(props);
        //this.buttonAction = this.buttonAction.bind(this);
        this.state = {
          user_blocked: [],
          childrenBlockedList: [],
          user_blocked_others: false,
          hasChildren: "",
        };
    }

    componentDidMount() {
        this.fetchHasChildren(this);
        this.fetchBlockedUsers(this);
    }

    fetchHasChildren(obj){
        AxiosConfig.get("profile/has_children/")
            .then(function (response){
                obj.setHasChildren(response);
            });
    }

    setHasChildren(response){
        this.setState((prevState) => ({
            hasChildren: response.data.has_children,
        }));
    }

    fetchBlockedUsers(obj){
        AxiosConfig.get("friends/blocked/")
            .then(function (response) {
                obj.setBlockedUserList(response);
            })
    }

    setBlockedUserList(response){
        let blockedUserList = response.data.my_blocked_users;
        let childBlockedList = response.data.children;
        this.setState((prevState) => ({
            user_blocked: blockedUserList,
            childrenBlockedList: childBlockedList,
        }));
    }

    render() {
        return (
            <div className="header_main main_blocked">
                <div className="page_main main_page">
                    <div id="vertical_spotlight_details">
                        <VerticalSpotlightDetails isSpotlightPage={false} />
                    </div>
                    <div className="page_details_main" >
                        <div className="page_details_content_main">
                            <div className="textHeader">{CONSTANT.YOUR_BLOCKED}</div>
                                    {this.state.user_blocked.length !== 0? (
                                        <BlockedListContainer
                                            buttonTitle={CONSTANT.UNBLOCK}
                                            blockedLists={this.state.user_blocked}
                                            datePrefix={CONSTANT.BLOCKED}
                                            type = {CONSTANT.BLOCKED_USERS}
                                        />
                                    ):(

                                         <div className = "message"
                                              style = {{textAlign: "center", padding: "0px", marginTop: "10px", marginBottom: "30px"}}
                                         >
                                           {CONSTANT.HAVE_NOT_BLOCKED_USERS}
                                         </div>
                                    )}
                            </div>
                            <br />

                            {this.state.hasChildren === "true" ? (
                                <div className="users_children">
                                     {this.state.childrenBlockedList.map((elem) => (
                                         <div>
                                         <div className="page_details_content_main" >
                                             <div className="textHeader">{elem.full_name + "'s " + CONSTANT.BLOCKED_USERS}</div>
                                                 {elem.blocked_users.length !== 0?
                                                    (
                                                         <BlockedListContainer
                                                            buttonTitle={CONSTANT.UNBLOCK}
                                                            blockedLists={elem.blocked_users}
                                                            datePrefix={CONSTANT.BLOCKED}
                                                            type = {CONSTANT.BLOCKED_USERS}
                                                         />
                                                    ):(
                                                         <div className = "message"
                                                               style = {{textAlign: "center", padding: "0px", marginTop: "10px", marginBottom: "30px"}}
                                                         >
                                                            {elem.full_name + CONSTANT.HAS_NOT_BLOCKED_USERS}
                                                        </div>
                                                    )
                                                 }
                                         </div>
                                         <br />
                                         </div>
                                     ))}
                                </div>
                            ) : (
                                <div className="user_has_no_children">
                                </div>
                                )}
                    </div>
                    </div>
                </div>
        );
    }
}

export default BlockedUsers;
